// Mock order lifecycle. A real FudiTap backend/KDS owns these transitions;
// the prototype advances them on a timer so the full flow is demoable.
export const ORDER_STATUS = {
  PLACED: "placed",
  PREPARING: "preparing",
  READY: "ready",
  SERVING: "serving",
  COMPLETED: "completed",
  CANCELED: "canceled",
};

// Happy-path progression shown in the timeline.
export const ORDER_FLOW = [
  ORDER_STATUS.PLACED,
  ORDER_STATUS.PREPARING,
  ORDER_STATUS.READY,
  ORDER_STATUS.SERVING,
  ORDER_STATUS.COMPLETED,
];

const TERMINAL = new Set([ORDER_STATUS.COMPLETED, ORDER_STATUS.CANCELED]);

// Statuses persisted by earlier prototype builds.
const LEGACY_STATUS = { received: ORDER_STATUS.PLACED };

export function isTerminalStatus(status) {
  return TERMINAL.has(status);
}

export function isOrderOpen(order) {
  return !!order && !isTerminalStatus(order.status);
}

export function nextStatus(status) {
  const i = ORDER_FLOW.indexOf(status);
  return i >= 0 && i < ORDER_FLOW.length - 1 ? ORDER_FLOW[i + 1] : null;
}

// Pure transition: returns a new order with the status + history updated.
export function advanceOrder(order, now = Date.now()) {
  const next = nextStatus(order.status);
  if (!next) return order;
  return {
    ...order,
    status: next,
    statusHistory: [...(order.statusHistory || []), { status: next, at: now }],
    ...(next === ORDER_STATUS.COMPLETED ? { completedAt: now } : {}),
  };
}

export function migrateOrder(order) {
  if (!order) return order;
  const status = LEGACY_STATUS[order.status] || order.status;
  return status === order.status ? order : { ...order, status };
}

// Snapshot cart lines into order lines. Combo lines keep their combo identity
// so "Order again" can reconstruct them later.
export function toOrderLines(detailed) {
  return detailed.map((l) => ({
    lineId: l.lineId,
    productId: l.isCombo ? undefined : l.productId,
    isCombo: !!l.isCombo,
    comboId: l.isCombo ? l.comboId : undefined,
    name: l.product?.name,
    image: l.product?.image,
    quantity: l.quantity,
    selections: l.selections,
    note: l.note,
    unitPrice: l.unitPrice,
    lineTotal: l.lineTotal,
  }));
}
